// extracted by mini-css-extract-plugin
export var backdropBlur = "_kw-0";
export var contentCard = "_kw-5";
export var frame = "_kw-2";
export var image = "_kw-4";
export var imagePane = "_kw-3";
export var modal = "_kw-1";